import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import { MonthlyParams, SalesDetailParams } from "api/businessDashboard";
import {
  getSalesApiPassType,
  salesDashboardTabOptions,
} from "constants/businessDashboard";

import { TotalSalesChart } from "./total-sales-chart";
import { MemberTabType, SalesTabType } from "types/BusinessDashboard";
import { AverageSellingPriceChart } from "./average-selling-price-chart";
import { UnitPriceChart } from "./unit-price-chart";

dayjs.locale("ko");

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`;

export const SalesChartSection = () => {
  const { searchParams } = useUpdateUrlParams();

  const activeTab = searchParams.get("tab") || salesDashboardTabOptions[0].id;
  const passType = getSalesApiPassType(activeTab);

  const referenceMonth = searchParams.get("month") || dayjs().format("YYYY-MM");
  const currentDate = dayjs(referenceMonth);

  const currentInnerTab = (searchParams.get("innerTab") ??
    "daily") as SalesTabType;
  const currentMembersInnerTab = (searchParams.get("innerMembersTab") ??
    "period") as MemberTabType;

  //@ts-expect-error: __
  const partnerInfo = useSelector((state) => state.partner);

  const detailApiParams = useMemo(() => {
    const params: SalesDetailParams = {
      referenceMonth,
      passType,
    };

    const seqParam = partnerInfo.seqPartner;
    const branchSeqParam = partnerInfo.seqPartnerBranch;

    if (seqParam) {
      params.seqPartner = Number(seqParam);
    }

    if (branchSeqParam) {
      params.seqPartnerBranch = Number(branchSeqParam);
    }

    return params;
  }, [referenceMonth, passType, partnerInfo]);

  const targetApiParams = useMemo(() => {
    const params: MonthlyParams = {
      referenceMonth,
    };

    const seqParam = partnerInfo.seqPartner;
    const branchSeqParam = partnerInfo.seqPartnerBranch;

    if (seqParam) {
      params.seqPartner = Number(seqParam);
    }

    if (branchSeqParam) {
      params.seqPartnerBranch = Number(branchSeqParam);
    }

    return params;
  }, [referenceMonth, partnerInfo]);

  return (
    <SectionWrapper>
      <TotalSalesChart
        currentDate={currentDate}
        detailApiParams={detailApiParams}
        targetApiParams={targetApiParams}
        currentInnerTab={currentInnerTab}
      />
      <AverageSellingPriceChart
        currentDate={currentDate}
        detailApiParams={detailApiParams}
        targetApiParams={targetApiParams}
      />
      <UnitPriceChart
        currentDate={currentDate}
        detailApiParams={detailApiParams}
        targetApiParams={targetApiParams}
        currentMembersInnerTab={currentMembersInnerTab}
      />
    </SectionWrapper>
  );
};
